[
  {
    "name": "Emilio Tadeo",
    "birthdate": "16/11/2005",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/441137835.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 180,
    "draftJersey": 12,
    "macros": {
      "physical": 80,
      "duels": 75,
      "shooting": 84,
      "defence": 87,
      "passing": 87,
      "skills": 79,
      "average": 82
    },
    "matchYtVideoId": "micMkoQodlQ",
    "profileYtVideoId": "6u-VC6nXt3w"
  },
  {
    "name": "Diego Ricoy",
    "birthdate": "02/04/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/202664963.png",
    "country": "Colombia",
    "role": "MC",
    "foot": "right",
    "height": 179,
    "draftJersey": 13,
    "macros": {
      "physical": 87,
      "duels": 92,
      "shooting": 77,
      "defence": 91,
      "passing": 86,
      "skills": 70,
      "average": 84
    },
    "matchYtVideoId": "jG94uNlKyoo",
    "profileYtVideoId": "34XP7vAAVYs"
  },
  {
    "name": "Edgar Martínez",
    "birthdate": "08/03/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/404273911.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 174,
    "draftJersey": 15,
    "macros": {
      "physical": 74,
      "duels": 82,
      "shooting": 93,
      "defence": 96,
      "passing": 87,
      "skills": 97,
      "average": 88
    },
    "matchYtVideoId": "micMkoQodlQ",
    "profileYtVideoId": "CDoXcgsuJzk"
  },
  {
    "name": "Jair Pérez",
    "birthdate": "12/02/1994",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/276573211.png",
    "country": "Colombia",
    "role": "DL",
    "foot": "left",
    "height": 178,
    "draftJersey": 16,
    "macros": {
      "physical": 88,
      "duels": 97,
      "shooting": 84,
      "defence": 78,
      "passing": 87,
      "skills": 97,
      "average": 89
    },
    "matchYtVideoId": "micMkoQodlQ",
    "profileYtVideoId": "66d_Q1nkJ4k"
  },
  {
    "name": "David Oteo",
    "birthdate": "27/07/1973",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/504471273.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "left",
    "height": 176,
    "draftJersey": 17,
    "macros": {
      "physical": 63,
      "duels": 88,
      "shooting": 77,
      "defence": 97,
      "passing": 92,
      "skills": 88,
      "average": 84
    },
    "matchYtVideoId": "micMkoQodlQ",
    "profileYtVideoId": "W8CEBFMHI44"
  },
  {
    "name": "Emmanuel Conde",
    "birthdate": "17/08/1987",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/899537331.png",
    "country": "Argentina",
    "role": "DL",
    "foot": "right",
    "height": 185,
    "draftJersey": 18,
    "macros": {
      "physical": 78,
      "duels": 74,
      "shooting": 71,
      "defence": 96,
      "passing": 86,
      "skills": 65,
      "average": 76
    },
    "matchYtVideoId": "micMkoQodlQ",
    "profileYtVideoId": "uEtXxmoIKLQ"
  },
  {
    "name": "Daniel Martínez",
    "birthdate": "21/01/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/308132958.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 175,
    "draftJersey": 19,
    "macros": {
      "physical": 84,
      "duels": 73,
      "shooting": 81,
      "defence": 86,
      "passing": 91,
      "skills": 51,
      "average": 78
    },
    "matchYtVideoId": "micMkoQodlQ",
    "profileYtVideoId": "LscbvRaLGPw"
  },
  {
    "name": "Abdoulaye Bangoura",
    "birthdate": "27/04/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/436062639.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 169,
    "draftJersey": 22,
    "macros": {
      "physical": 93,
      "duels": 89,
      "shooting": 84,
      "defence": 92,
      "passing": 79,
      "skills": 88,
      "average": 87
    },
    "matchYtVideoId": "micMkoQodlQ",
    "profileYtVideoId": "MTcvsH8WL90"
  },
  {
    "name": "Erick Madrigal",
    "birthdate": "12/05/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/142123303.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "left",
    "height": 183,
    "draftJersey": 23,
    "macros": {
      "physical": 87,
      "duels": 93,
      "shooting": 67,
      "defence": 84,
      "passing": 96,
      "skills": 79,
      "average": 84
    },
    "matchYtVideoId": "jG94uNlKyoo",
    "profileYtVideoId": "uQ899RPU2jA"
  },
  {
    "name": "Isaac Mora",
    "birthdate": "18/04/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/415614815.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 165,
    "draftJersey": 24,
    "macros": {
      "physical": 83,
      "duels": 75,
      "shooting": 79,
      "defence": 82,
      "passing": 92,
      "skills": 97,
      "average": 85
    },
    "matchYtVideoId": "jG94uNlKyoo",
    "profileYtVideoId": "L7-tLeLqLdg"
  },
  {
    "name": "Rodolfo Castañeda",
    "birthdate": "14/02/2005",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/697584779.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 155,
    "draftJersey": 25,
    "macros": {
      "physical": 84,
      "duels": 74,
      "shooting": 73,
      "defence": 82,
      "passing": 81,
      "skills": 87,
      "average": 80
    },
    "matchYtVideoId": "jG94uNlKyoo",
    "profileYtVideoId": "7p4EIwGsjjA"
  },
  {
    "name": "Michael Angulo",
    "birthdate": "06/01/1994",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/591049688.png",
    "country": "Ecuador",
    "role": "DL",
    "foot": "left",
    "height": 188,
    "draftJersey": 28,
    "macros": {
      "physical": 74,
      "duels": 88,
      "shooting": 72,
      "defence": 90,
      "passing": 92,
      "skills": 70,
      "average": 80
    },
    "matchYtVideoId": "jG94uNlKyoo",
    "profileYtVideoId": "alKJ8MBvYkg"
  },
  {
    "name": "Iván Solís",
    "birthdate": "17/02/2002",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/377934663.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 171,
    "draftJersey": 30,
    "macros": {
      "physical": 74,
      "duels": 79,
      "shooting": 64,
      "defence": 97,
      "passing": 87,
      "skills": 75,
      "average": 79
    },
    "matchYtVideoId": "jG94uNlKyoo",
    "profileYtVideoId": "4RIx890Lebo"
  },
  {
    "name": "Samuel Pascoe",
    "birthdate": "29/01/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/18590374.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 173,
    "draftJersey": 31,
    "macros": {
      "physical": 88,
      "duels": 75,
      "shooting": 90,
      "defence": 97,
      "passing": 93,
      "skills": 94,
      "average": 90
    },
    "matchYtVideoId": "jG94uNlKyoo",
    "profileYtVideoId": "eN46RwiRF5g"
  },
  {
    "name": "David Pérez",
    "birthdate": "21/07/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/16492904.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 170,
    "draftJersey": 34,
    "macros": {
      "physical": 72,
      "duels": 86,
      "shooting": 78,
      "defence": 97,
      "passing": 88,
      "skills": 76,
      "average": 81
    },
    "matchYtVideoId": "jG94uNlKyoo",
    "profileYtVideoId": "3S8xfVchF2o"
  },
  {
    "name": "David Vizcarra",
    "birthdate": "22/12/1990",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/360634308.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 172,
    "draftJersey": 36,
    "macros": {
      "physical": 69,
      "duels": 88,
      "shooting": 82,
      "defence": 82,
      "passing": 98,
      "skills": 80,
      "average": 84
    },
    "matchYtVideoId": "z_AfMOID0GU",
    "profileYtVideoId": "Z2bMnQ90a0U"
  },
  {
    "name": "Diego Pérez",
    "birthdate": "25/06/2006",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/222585523.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 170,
    "draftJersey": 37,
    "macros": {
      "physical": 69,
      "duels": 70,
      "shooting": 81,
      "defence": 80,
      "passing": 93,
      "skills": 71,
      "average": 78
    },
    "matchYtVideoId": "z_AfMOID0GU",
    "profileYtVideoId": "FjTs8HtmfIs"
  },
  {
    "name": "Ricardo Santana",
    "birthdate": "11/12/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/714568292.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 170,
    "draftJersey": 38,
    "macros": {
      "physical": 75,
      "duels": 75,
      "shooting": 81,
      "defence": 80,
      "passing": 97,
      "skills": 52,
      "average": 78
    },
    "matchYtVideoId": "-YqVg8StXb0",
    "profileYtVideoId": "ktNjkFJbBHY"
  },
  {
    "name": "Keiber Meza",
    "birthdate": "22/09/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/687115246.png",
    "country": "Colombia",
    "role": "DF",
    "foot": "right",
    "height": 178,
    "draftJersey": 40,
    "macros": {
      "physical": 86,
      "duels": 67,
      "shooting": 55,
      "defence": 83,
      "passing": 95,
      "skills": 59,
      "average": 77
    },
    "matchYtVideoId": "-YqVg8StXb0",
    "profileYtVideoId": "MuToArN7xiw"
  },
  {
    "name": "David Gaistman",
    "birthdate": "27/07/1994",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/241113527.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "left",
    "height": 188,
    "draftJersey": 41,
    "macros": {
      "physical": 71,
      "duels": 86,
      "shooting": 74,
      "defence": 83,
      "passing": 95,
      "skills": 87,
      "average": 82
    },
    "matchYtVideoId": "-YqVg8StXb0",
    "profileYtVideoId": "0mvSJmVcjDA"
  },
  {
    "name": "Gerson Villarreal",
    "birthdate": "05/06/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/380440963.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 172,
    "draftJersey": 42,
    "macros": {
      "physical": 70,
      "duels": 83,
      "shooting": 78,
      "defence": 84,
      "passing": 91,
      "skills": 96,
      "average": 84
    },
    "matchYtVideoId": "z_AfMOID0GU",
    "profileYtVideoId": "8vp_lNeIO6Y"
  },
  {
    "name": "Carlos Espinoza",
    "birthdate": "05/12/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/316665429.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 163,
    "draftJersey": 43,
    "macros": {
      "physical": 81,
      "duels": 88,
      "shooting": 76,
      "defence": 93,
      "passing": 92,
      "skills": 97,
      "average": 87
    },
    "matchYtVideoId": "-YqVg8StXb0",
    "profileYtVideoId": "TxXBjWJOKm8"
  },
  {
    "name": "Iván Osorio",
    "birthdate": "23/09/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/878308398.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 174,
    "draftJersey": 45,
    "macros": {
      "physical": 76,
      "duels": 74,
      "shooting": 79,
      "defence": 90,
      "passing": 81,
      "skills": 69,
      "average": 79
    },
    "matchYtVideoId": "-YqVg8StXb0",
    "profileYtVideoId": "MFKz-bdk5QM"
  },
  {
    "name": "Obed González",
    "birthdate": "21/06/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/874722229.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 172,
    "draftJersey": 46,
    "macros": {
      "physical": 71,
      "duels": 96,
      "shooting": 75,
      "defence": 86,
      "passing": 97,
      "skills": 87,
      "average": 84
    },
    "matchYtVideoId": "z_AfMOID0GU",
    "profileYtVideoId": "1HVloDCVlpk"
  },
  {
    "name": "Denilson Lobon",
    "birthdate": "15/03/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/245589344.png",
    "country": "Colombia",
    "role": "DF",
    "foot": "right",
    "height": 189,
    "draftJersey": 47,
    "macros": {
      "physical": 89,
      "duels": 77,
      "shooting": 72,
      "defence": 97,
      "passing": 79,
      "skills": 61,
      "average": 83
    },
    "matchYtVideoId": "z_AfMOID0GU",
    "profileYtVideoId": "Rb7KNdUat2s"
  },
  {
    "name": "Christian Romero",
    "birthdate": "21/06/1986",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/973231174.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 180,
    "draftJersey": 48,
    "macros": {
      "physical": 67,
      "duels": 67,
      "shooting": 77,
      "defence": 91,
      "passing": 80,
      "skills": 52,
      "average": 76
    },
    "matchYtVideoId": "jG94uNlKyoo",
    "profileYtVideoId": "K0H1hQMWOf8"
  },
  {
    "name": "Brayam Nazarit",
    "birthdate": "15/05/1992",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/948824580.png",
    "country": "Colombia",
    "role": "MC",
    "foot": "left",
    "height": 177,
    "draftJersey": 49,
    "macros": {
      "physical": 85,
      "duels": 88,
      "shooting": 70,
      "defence": 97,
      "passing": 88,
      "skills": 97,
      "average": 87
    },
    "matchYtVideoId": "z_AfMOID0GU",
    "profileYtVideoId": "Uf6MKkOAzOA"
  },
  {
    "name": "Jorge Escamilla",
    "birthdate": "01/11/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/488326918.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 180,
    "draftJersey": 51,
    "macros": {
      "physical": 84,
      "duels": 85,
      "shooting": 89,
      "defence": 98,
      "passing": 89,
      "skills": 99,
      "average": 90
    },
    "matchYtVideoId": "z_AfMOID0GU",
    "profileYtVideoId": "l6MfFMGk-aM"
  },
  {
    "name": "Juan Cruz",
    "birthdate": "27/07/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/965219769.png",
    "country": "Argentina",
    "role": "MC",
    "foot": "right",
    "height": 167,
    "draftJersey": 53,
    "macros": {
      "physical": 84,
      "duels": 90,
      "shooting": 67,
      "defence": 91,
      "passing": 83,
      "skills": 79,
      "average": 81
    },
    "matchYtVideoId": "z_AfMOID0GU",
    "profileYtVideoId": "c1jiuOW0QVQ"
  },
  {
    "name": "Abayubá Duché",
    "birthdate": "28/06/1991",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/629686893.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 170,
    "draftJersey": 54,
    "macros": {
      "physical": 86,
      "duels": 91,
      "shooting": 82,
      "defence": 97,
      "passing": 79,
      "skills": 97,
      "average": 88
    },
    "matchYtVideoId": "z_AfMOID0GU",
    "profileYtVideoId": "hgLSEK5fRkY"
  },
  {
    "name": "Josué Cosio",
    "birthdate": "27/03/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/699486144.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 179,
    "draftJersey": 55,
    "macros": {
      "physical": 80,
      "duels": 79,
      "shooting": 82,
      "defence": 92,
      "passing": 78,
      "skills": 88,
      "average": 83
    },
    "matchYtVideoId": "z_AfMOID0GU",
    "profileYtVideoId": "u9k-jZUPkjI"
  },
  {
    "name": "Enrique Lagarde",
    "birthdate": "04/09/1993",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/352800486.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 188,
    "draftJersey": 69,
    "macros": {
      "physical": 66,
      "duels": 80,
      "shooting": 86,
      "defence": 97,
      "passing": 96,
      "skills": 88,
      "average": 86
    },
    "matchYtVideoId": "pWP_V2U89rY",
    "profileYtVideoId": "nAFlZzFmsuQ"
  },
  {
    "name": "Enrique Ciprian",
    "birthdate": "15/11/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/472660207.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 172,
    "draftJersey": 72,
    "macros": {
      "physical": 89,
      "duels": 69,
      "shooting": 68,
      "defence": 91,
      "passing": 86,
      "skills": 61,
      "average": 77
    },
    "matchYtVideoId": "pWP_V2U89rY",
    "profileYtVideoId": "SeIvvjJI-fc"
  },
  {
    "name": "Alexis Benítez",
    "birthdate": "21/04/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/551154847.png",
    "country": "Paraguay",
    "role": "DL",
    "foot": "right",
    "height": 170,
    "draftJersey": 74,
    "macros": {
      "physical": 76,
      "duels": 79,
      "shooting": 83,
      "defence": 88,
      "passing": 80,
      "skills": 61,
      "average": 78
    },
    "matchYtVideoId": "pWP_V2U89rY",
    "profileYtVideoId": "SDHebrZ7bPg"
  },
  {
    "name": "Leandro Torres",
    "birthdate": "04/11/1988",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/262295714.png",
    "country": "Argentina",
    "role": "MC",
    "foot": "right",
    "height": 168,
    "draftJersey": 76,
    "macros": {
      "physical": 67,
      "duels": 74,
      "shooting": 74,
      "defence": 86,
      "passing": 86,
      "skills": 79,
      "average": 78
    },
    "matchYtVideoId": "pWP_V2U89rY",
    "profileYtVideoId": "rMc6M9_njRA"
  },
  {
    "name": "Charbell Ruiz",
    "birthdate": "19/06/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/927962028.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 167,
    "draftJersey": 77,
    "macros": {
      "physical": 81,
      "duels": 77,
      "shooting": 77,
      "defence": 85,
      "passing": 74,
      "skills": 77,
      "average": 78
    },
    "matchYtVideoId": "pWP_V2U89rY",
    "profileYtVideoId": "f1Kv1j_tiE4"
  },
  {
    "name": "Adrián Marín",
    "birthdate": "13/05/1994",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/458571000.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 168,
    "draftJersey": 78,
    "macros": {
      "physical": 75,
      "duels": 84,
      "shooting": 81,
      "defence": 84,
      "passing": 82,
      "skills": 97,
      "average": 84
    },
    "matchYtVideoId": "pWP_V2U89rY",
    "profileYtVideoId": "_4zDII8TgZ4"
  },
  {
    "name": "Leonardo Duque",
    "birthdate": "02/10/2003",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/160210126.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 168,
    "draftJersey": 79,
    "macros": {
      "physical": 87,
      "duels": 89,
      "shooting": 72,
      "defence": 96,
      "passing": 82,
      "skills": 88,
      "average": 84
    },
    "matchYtVideoId": "pWP_V2U89rY",
    "profileYtVideoId": "KVNfqfkPGJw"
  },
  {
    "name": "Santiago López",
    "birthdate": "16/11/2005",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/101896945.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 178,
    "draftJersey": 80,
    "macros": {
      "physical": 79,
      "duels": 69,
      "shooting": 71,
      "defence": 96,
      "passing": 83,
      "skills": 78,
      "average": 77
    },
    "matchYtVideoId": "pWP_V2U89rY",
    "profileYtVideoId": "FYNefd5D8z0"
  },
  {
    "name": "Roberto Vázquez",
    "birthdate": "14/04/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/202622022.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 180,
    "draftJersey": 81,
    "macros": {
      "physical": 86,
      "duels": 87,
      "shooting": 72,
      "defence": 73,
      "passing": 82,
      "skills": 78,
      "average": 79
    },
    "matchYtVideoId": "V9gvCo9fK-k",
    "profileYtVideoId": "DsnFwjZpfRM"
  },
  {
    "name": "Mario Calderón",
    "birthdate": "03/03/1993",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/72264316.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 170,
    "draftJersey": 82,
    "macros": {
      "physical": 73,
      "duels": 75,
      "shooting": 75,
      "defence": 82,
      "passing": 84,
      "skills": 70,
      "average": 77
    },
    "matchYtVideoId": "V9gvCo9fK-k",
    "profileYtVideoId": "lckyNZ6JWuA"
  },
  {
    "name": "Jorge Gonzalez",
    "birthdate": "14/03/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/272278810.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 172,
    "draftJersey": 85,
    "macros": {
      "physical": 83,
      "duels": 78,
      "shooting": 71,
      "defence": 87,
      "passing": 81,
      "skills": 87,
      "average": 79
    },
    "matchYtVideoId": "V9gvCo9fK-k",
    "profileYtVideoId": "U-3PtIecQX4"
  },
  {
    "name": "Eder Uscanga",
    "birthdate": "27/11/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/111967728.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 185,
    "draftJersey": 87,
    "macros": {
      "physical": 81,
      "duels": 88,
      "shooting": 72,
      "defence": 88,
      "passing": 78,
      "skills": 88,
      "average": 82
    },
    "matchYtVideoId": "V9gvCo9fK-k",
    "profileYtVideoId": "EOuKeDScVZ4"
  },
  {
    "name": "Javier Gallegos",
    "birthdate": "08/11/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/799887866.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 176,
    "draftJersey": 89,
    "macros": {
      "physical": 77,
      "duels": 93,
      "shooting": 75,
      "defence": 88,
      "passing": 76,
      "skills": 79,
      "average": 81
    },
    "matchYtVideoId": "V9gvCo9fK-k",
    "profileYtVideoId": "plqaFQPiBxQ"
  },
  {
    "name": "Jorge Leal",
    "birthdate": "26/01/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/581178270.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 176,
    "draftJersey": 90,
    "macros": {
      "physical": 77,
      "duels": 79,
      "shooting": 75,
      "defence": 93,
      "passing": 87,
      "skills": 79,
      "average": 81
    },
    "matchYtVideoId": "V9gvCo9fK-k",
    "profileYtVideoId": "qIFVJNGCZfk"
  },
  {
    "name": "Carlos Monroy",
    "birthdate": "22/11/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/924681545.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 175,
    "draftJersey": 92,
    "macros": {
      "physical": 93,
      "duels": 74,
      "shooting": 72,
      "defence": 96,
      "passing": 75,
      "skills": 69,
      "average": 78
    },
    "matchYtVideoId": "V9gvCo9fK-k",
    "profileYtVideoId": "zJgmnOvtoDg"
  },
  {
    "name": "Renan Ramos",
    "birthdate": "18/11/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/733864928.png",
    "country": "Brazil",
    "role": "MC",
    "foot": "right",
    "height": 175,
    "draftJersey": 95,
    "macros": {
      "physical": 90,
      "duels": 74,
      "shooting": 70,
      "defence": 82,
      "passing": 71,
      "skills": 60,
      "average": 74
    },
    "matchYtVideoId": "sZPK0-NQQtI",
    "profileYtVideoId": "WHb9tk_T62s"
  },
  {
    "name": "José Lara",
    "birthdate": "25/07/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/929566933.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 166,
    "draftJersey": 96,
    "macros": {
      "physical": 82,
      "duels": 79,
      "shooting": 75,
      "defence": 93,
      "passing": 77,
      "skills": 71,
      "average": 79
    },
    "matchYtVideoId": "sZPK0-NQQtI",
    "profileYtVideoId": "1Bgm-jAdwfc"
  },
  {
    "name": "Kevin Valdez",
    "birthdate": "24/07/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/331724810.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 176,
    "draftJersey": 99,
    "macros": {
      "physical": 82,
      "duels": 83,
      "shooting": 92,
      "defence": 97,
      "passing": 75,
      "skills": 61,
      "average": 85
    },
    "matchYtVideoId": "PCm93Pg61jY",
    "profileYtVideoId": "saMLCWML6wU"
  },
  {
    "name": "Fernando Morales",
    "birthdate": "14/09/1985",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/861983815.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 173,
    "draftJersey": 101,
    "macros": {
      "physical": 68,
      "duels": 78,
      "shooting": 76,
      "defence": 76,
      "passing": 76,
      "skills": 87,
      "average": 77
    },
    "matchYtVideoId": "{matchLink: null",
    "profileYtVideoId": "cfNBOoilfaU"
  },
  {
    "name": "César Ramírez",
    "birthdate": "18/03/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/684711124.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 178,
    "draftJersey": 104,
    "macros": {
      "physical": 70,
      "duels": 70,
      "shooting": 81,
      "defence": 88,
      "passing": 83,
      "skills": 71,
      "average": 77
    },
    "matchYtVideoId": "PCm93Pg61jY",
    "profileYtVideoId": "DQYGRCZJcoU"
  },
  {
    "name": "Hernán Cepeda",
    "birthdate": "25/11/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/889808328.png",
    "country": "Ecuador",
    "role": "DF",
    "foot": "right",
    "height": 179,
    "draftJersey": 105,
    "macros": {
      "physical": 80,
      "duels": 78,
      "shooting": 82,
      "defence": 92,
      "passing": 73,
      "skills": 69,
      "average": 82
    },
    "matchYtVideoId": "sZPK0-NQQtI",
    "profileYtVideoId": "K8a7bLD7ROk"
  },
  {
    "name": "Uriel Sosa",
    "birthdate": "05/07/2024",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/619770901.png",
    "country": "Argentina",
    "role": "MC",
    "foot": "right",
    "height": 175,
    "draftJersey": 106,
    "macros": {
      "physical": 83,
      "duels": 84,
      "shooting": 73,
      "defence": 88,
      "passing": 87,
      "skills": 52,
      "average": 78
    },
    "matchYtVideoId": "PCm93Pg61jY",
    "profileYtVideoId": "2XDnDxeMrHM"
  },
  {
    "name": "Jorge Gamez",
    "birthdate": "15/01/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/29785889.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 175,
    "draftJersey": 107,
    "macros": {
      "physical": 73,
      "duels": 92,
      "shooting": 76,
      "defence": 84,
      "passing": 76,
      "skills": 87,
      "average": 81
    },
    "matchYtVideoId": "PCm93Pg61jY",
    "profileYtVideoId": "F7cLSVhs9vU"
  },
  {
    "name": "Juan Cisneros",
    "birthdate": "06/05/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/522246056.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 160,
    "draftJersey": 112,
    "macros": {
      "physical": 81,
      "duels": 84,
      "shooting": 78,
      "defence": 97,
      "passing": 77,
      "skills": 80,
      "average": 82
    },
    "matchYtVideoId": "PCm93Pg61jY",
    "profileYtVideoId": "ar_tfxypOBI"
  },
  {
    "name": "Santiago Velasco",
    "birthdate": "19/07/2004",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/61098502.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 172,
    "draftJersey": 113,
    "macros": {
      "physical": 74,
      "duels": 78,
      "shooting": 78,
      "defence": 91,
      "passing": 66,
      "skills": 52,
      "average": 73
    },
    "matchYtVideoId": "PCm93Pg61jY",
    "profileYtVideoId": "cYo5srb7IGY"
  },
  {
    "name": "Brandon García",
    "birthdate": "22/01/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/352540864.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 170,
    "draftJersey": 114,
    "macros": {
      "physical": 77,
      "duels": 79,
      "shooting": 83,
      "defence": 97,
      "passing": 76,
      "skills": 70,
      "average": 80
    },
    "matchYtVideoId": "PCm93Pg61jY",
    "profileYtVideoId": "RTkpO0W0Iiw"
  },
  {
    "name": "Ángel Duque",
    "birthdate": "10/06/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/658128314.png",
    "country": "Venezuela",
    "role": "DF",
    "foot": "right",
    "height": 176,
    "draftJersey": 127,
    "macros": {
      "physical": 82,
      "duels": 70,
      "shooting": 68,
      "defence": 93,
      "passing": 92,
      "skills": 70,
      "average": 82
    },
    "matchYtVideoId": "SfSCnEEBcnM",
    "profileYtVideoId": "onMWlVOXjqI"
  },
  {
    "name": "Thomas González",
    "birthdate": "30/03/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/469871023.png",
    "country": "Argentina",
    "role": "MC",
    "foot": "right",
    "height": 170,
    "draftJersey": 128,
    "macros": {
      "physical": 81,
      "duels": 70,
      "shooting": 69,
      "defence": 78,
      "passing": 86,
      "skills": 69,
      "average": 76
    },
    "matchYtVideoId": "SfSCnEEBcnM",
    "profileYtVideoId": "q5ukDrt4goA"
  },
  {
    "name": "Stephan D'Alessandro",
    "birthdate": "05/07/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/364185128.png",
    "country": "Dominican Republic",
    "role": "MC",
    "foot": "left",
    "height": 182,
    "draftJersey": 131,
    "macros": {
      "physical": 91,
      "duels": 60,
      "shooting": 70,
      "defence": 74,
      "passing": 63,
      "skills": 69,
      "average": 71
    },
    "matchYtVideoId": "tycPL656lGE",
    "profileYtVideoId": "5XVyvXQlIz0"
  },
  {
    "name": "Yamil Tannous",
    "birthdate": "26/09/1992",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/763656675.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 182,
    "draftJersey": 132,
    "macros": {
      "physical": 80,
      "duels": 84,
      "shooting": 86,
      "defence": 80,
      "passing": 83,
      "skills": 89,
      "average": 84
    },
    "matchYtVideoId": "SfSCnEEBcnM",
    "profileYtVideoId": "6jthZW08JH0"
  },
  {
    "name": "Brain Reyes",
    "birthdate": "29/03/1992",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/185864185.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 177,
    "draftJersey": 135,
    "macros": {
      "physical": 78,
      "duels": 79,
      "shooting": 70,
      "defence": 84,
      "passing": 87,
      "skills": 70,
      "average": 78
    },
    "matchYtVideoId": "tycPL656lGE",
    "profileYtVideoId": "eiFBWYkGBDw"
  },
  {
    "name": "Rodrigo Pedroza",
    "birthdate": "26/10/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/281931215.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 194,
    "draftJersey": 137,
    "macros": {
      "physical": 71,
      "duels": 83,
      "shooting": 68,
      "defence": 91,
      "passing": 91,
      "skills": 69,
      "average": 81
    },
    "matchYtVideoId": "tycPL656lGE",
    "profileYtVideoId": "GZgsFqc5CEI"
  },
  {
    "name": "Gabriel Áviles",
    "birthdate": "17/08/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/13406330.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "left",
    "height": 178,
    "draftJersey": 139,
    "macros": {
      "physical": 75,
      "duels": 70,
      "shooting": 79,
      "defence": 92,
      "passing": 87,
      "skills": 79,
      "average": 82
    },
    "matchYtVideoId": "SfSCnEEBcnM",
    "profileYtVideoId": "Qec91KhsU8U"
  },
  {
    "name": "Víctor Pérez",
    "birthdate": "19/03/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/0b194ce9-4433-45a9-932b-07b817f466ab/159556.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 168,
    "draftJersey": 140,
    "macros": {
      "physical": 81,
      "duels": 70,
      "shooting": 74,
      "defence": 97,
      "passing": 84,
      "skills": 80,
      "average": 81
    },
    "matchYtVideoId": "SfSCnEEBcnM",
    "profileYtVideoId": "bLe2L37xwPY"
  },
  {
    "name": "Ricardo Vaca",
    "birthdate": "06/10/1993",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/710912024.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 170,
    "draftJersey": 143,
    "macros": {
      "physical": 88,
      "duels": 84,
      "shooting": 85,
      "defence": 80,
      "passing": 76,
      "skills": 79,
      "average": 82
    },
    "matchYtVideoId": "SfSCnEEBcnM",
    "profileYtVideoId": "wKwmtMmBWZk"
  },
  {
    "name": "Daniel López",
    "birthdate": "16/05/1995",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/111994863.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 188,
    "draftJersey": 145,
    "macros": {
      "physical": 85,
      "duels": 80,
      "shooting": 73,
      "defence": 94,
      "passing": 79,
      "skills": 80,
      "average": 84
    },
    "matchYtVideoId": "SfSCnEEBcnM",
    "profileYtVideoId": "UZ18aQU2y1w"
  },
  {
    "name": "Ricardo Valencia",
    "birthdate": "20/08/1990",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/269178810.png",
    "country": "Colombia",
    "role": "MC",
    "foot": "right",
    "height": 172,
    "draftJersey": 149,
    "macros": {
      "physical": 84,
      "duels": 70,
      "shooting": 78,
      "defence": 93,
      "passing": 70,
      "skills": 79,
      "average": 79
    },
    "matchYtVideoId": "SfSCnEEBcnM",
    "profileYtVideoId": "6KhPez2Tpjo"
  },
  {
    "name": "Erick Sámano",
    "birthdate": "04/06/1991",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/660739410.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "left",
    "height": 184,
    "draftJersey": 151,
    "macros": {
      "physical": 74,
      "duels": 61,
      "shooting": 84,
      "defence": 92,
      "passing": 92,
      "skills": 61,
      "average": 81
    },
    "matchYtVideoId": "CViP_eshlG8",
    "profileYtVideoId": "6tsguPiBxV0"
  },
  {
    "name": "Juan Gómez",
    "birthdate": "10/03/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/380337344.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "left",
    "height": 170,
    "draftJersey": 154,
    "macros": {
      "physical": 92,
      "duels": 69,
      "shooting": 67,
      "defence": 86,
      "passing": 83,
      "skills": 51,
      "average": 79
    },
    "matchYtVideoId": "CViP_eshlG8",
    "profileYtVideoId": "lk2P91zSXhI"
  },
  {
    "name": "Jorge Meléndez",
    "birthdate": "08/12/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/775193440.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 170,
    "draftJersey": 155,
    "macros": {
      "physical": 82,
      "duels": 88,
      "shooting": 67,
      "defence": 92,
      "passing": 78,
      "skills": 79,
      "average": 80
    },
    "matchYtVideoId": "CViP_eshlG8",
    "profileYtVideoId": "XD8gEDDdbws"
  },
  {
    "name": "Sergio Meza",
    "birthdate": "22/03/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/962769778.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 183,
    "draftJersey": 156,
    "macros": {
      "physical": 67,
      "duels": 93,
      "shooting": 74,
      "defence": 96,
      "passing": 87,
      "skills": 88,
      "average": 82
    },
    "matchYtVideoId": "sZPK0-NQQtI",
    "profileYtVideoId": "1PEfoEQ6OTs"
  },
  {
    "name": "Johan Olay",
    "birthdate": "14/11/2000",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/982947097.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 170,
    "draftJersey": 158,
    "macros": {
      "physical": 75,
      "duels": 75,
      "shooting": 85,
      "defence": 82,
      "passing": 78,
      "skills": 98,
      "average": 82
    },
    "matchYtVideoId": "CViP_eshlG8",
    "profileYtVideoId": "dT6Pavq3Ekk"
  },
  {
    "name": "Sergio Herreño",
    "birthdate": "19/12/1986",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/317396626.png",
    "country": "Colombia",
    "role": "MC",
    "foot": "right",
    "height": 170,
    "draftJersey": 159,
    "macros": {
      "physical": 73,
      "duels": 79,
      "shooting": 68,
      "defence": 88,
      "passing": 88,
      "skills": 70,
      "average": 78
    },
    "matchYtVideoId": "CViP_eshlG8",
    "profileYtVideoId": "7Akp4R6PzzY"
  },
  {
    "name": "Fidel Cabrera",
    "birthdate": "17/10/1990",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/563548380.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "right",
    "height": 166,
    "draftJersey": 162,
    "macros": {
      "physical": 75,
      "duels": 75,
      "shooting": 87,
      "defence": 84,
      "passing": 82,
      "skills": 79,
      "average": 81
    },
    "matchYtVideoId": "CViP_eshlG8",
    "profileYtVideoId": "5kbhWAF9494"
  },
  {
    "name": "Guillermo Jiménez",
    "birthdate": "24/07/1993",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/526486259.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 189,
    "draftJersey": 163,
    "macros": {
      "physical": 71,
      "duels": 79,
      "shooting": 84,
      "defence": 85,
      "passing": 78,
      "skills": 79,
      "average": 80
    },
    "matchYtVideoId": "sZPK0-NQQtI",
    "profileYtVideoId": "FKnoGxlZk7U"
  },
  {
    "name": "Jesús Félix",
    "birthdate": "13/07/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/269442897.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 169,
    "draftJersey": 164,
    "macros": {
      "physical": 66,
      "duels": 79,
      "shooting": 79,
      "defence": 84,
      "passing": 78,
      "skills": 79,
      "average": 77
    },
    "matchYtVideoId": "sZPK0-NQQtI",
    "profileYtVideoId": "f572upZS0gk"
  },
  {
    "name": "Máximo Valderrama",
    "birthdate": "23/03/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/618614212.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "left",
    "height": 170,
    "draftJersey": 165,
    "macros": {
      "physical": 79,
      "duels": 74,
      "shooting": 75,
      "defence": 88,
      "passing": 82,
      "skills": 78,
      "average": 79
    },
    "matchYtVideoId": "sZPK0-NQQtI",
    "profileYtVideoId": "up3rfwd2Okg"
  },
  {
    "name": "Francisco Becerril",
    "birthdate": "03/09/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/326484880.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 179,
    "draftJersey": 167,
    "macros": {
      "physical": 72,
      "duels": 78,
      "shooting": 84,
      "defence": 77,
      "passing": 80,
      "skills": 78,
      "average": 79
    },
    "matchYtVideoId": "sZPK0-NQQtI",
    "profileYtVideoId": "YF95I4sk2Jo"
  },
  {
    "name": "Diego Murillo",
    "birthdate": "09/06/2001",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/760408127.png",
    "country": "Mexico",
    "role": "DL",
    "foot": "left",
    "height": 173,
    "draftJersey": 168,
    "macros": {
      "physical": 71,
      "duels": 78,
      "shooting": 81,
      "defence": 91,
      "passing": 79,
      "skills": 78,
      "average": 79
    },
    "matchYtVideoId": "sZPK0-NQQtI",
    "profileYtVideoId": "P9DRaExt_a4"
  },
  {
    "name": "Christian Lagunas",
    "birthdate": "07/08/1999",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/988080692.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 175,
    "draftJersey": 173,
    "macros": {
      "physical": 75,
      "duels": 74,
      "shooting": 73,
      "defence": 81,
      "passing": 82,
      "skills": 60,
      "average": 75
    },
    "matchYtVideoId": "sZPK0-NQQtI",
    "profileYtVideoId": "RwnxYNVKhyo"
  },
  {
    "name": "Renzo De la Rosa",
    "birthdate": "07/06/1993",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/187349315.png",
    "country": "Venezuela",
    "role": "MC",
    "foot": "left",
    "height": 180,
    "draftJersey": 175,
    "macros": {
      "physical": 80,
      "duels": 70,
      "shooting": 72,
      "defence": 79,
      "passing": 76,
      "skills": 61,
      "average": 73
    },
    "matchYtVideoId": "PCm93Pg61jY",
    "profileYtVideoId": "hTIDATYRnjg"
  },
  {
    "name": "Miguel Lizardo",
    "birthdate": "06/06/1997",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/524084583.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 180,
    "draftJersey": 177,
    "macros": {
      "physical": 84,
      "duels": 87,
      "shooting": 73,
      "defence": 87,
      "passing": 77,
      "skills": 87,
      "average": 82
    },
    "matchYtVideoId": "PCm93Pg61jY",
    "profileYtVideoId": "3j7bQDMDo6k"
  },
  {
    "name": "Francisco Guzmán",
    "birthdate": "31/05/1998",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/764152944.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 170,
    "draftJersey": 182,
    "macros": {
      "physical": 69,
      "duels": 75,
      "shooting": 72,
      "defence": 83,
      "passing": 82,
      "skills": 61,
      "average": 74
    },
    "matchYtVideoId": "39ui0LcCB8M",
    "profileYtVideoId": "jq13hBfBPmM"
  },
  {
    "name": "Eduardo Velarde",
    "birthdate": "21/01/2005",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/415114920.png",
    "country": "Mexico",
    "role": "DF",
    "foot": "right",
    "height": 171,
    "draftJersey": 184,
    "macros": {
      "physical": 84,
      "duels": 65,
      "shooting": 83,
      "defence": 97,
      "passing": 80,
      "skills": 80,
      "average": 85
    },
    "matchYtVideoId": "PCm93Pg61jY",
    "profileYtVideoId": "m4ggwSd9eOw"
  },
  {
    "name": "Pabel Montes",
    "birthdate": "27/08/1996",
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/837274917.png",
    "country": "Mexico",
    "role": "MC",
    "foot": "right",
    "height": 172,
    "draftJersey": 198,
    "macros": {
      "physical": 77,
      "duels": 93,
      "shooting": 81,
      "defence": 92,
      "passing": 97,
      "skills": 88,
      "average": 88
    },
    "matchYtVideoId": "jG94uNlKyoo",
    "profileYtVideoId": "sdT2IRooMbE"
  },
  {
    "draftJersey": 135,
    "draftJerseyPrefix": "MED",
    "role": "MC",
    "name": "Emanuel Sierra",
    "foot": "right",
    "height": 174,
    "birthdate": "10/02/2005",
    "country": "COL",
    "macros": {
      "physical": 70,
      "duels": 88,
      "shooting": 82,
      "passing": 81,
      "defence": 91,
      "skills": 79,
      "average": 82
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/161177648.png",
    "profileYtVideoId": "GLI_S_i9E-g",
    "matchYtVideoId": "1pz_S_lql38"
  },
  {
    "draftJersey": 81,
    "draftJerseyPrefix": "MED",
    "role": "MC",
    "name": "José Sastoque",
    "foot": "left",
    "height": 176,
    "birthdate": "23/05/2000",
    "country": "COL",
    "macros": {
      "physical": 75,
      "duels": 88,
      "shooting": 77,
      "passing": 83,
      "defence": 71,
      "skills": 92,
      "average": 81
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/216125543.png",
    "profileYtVideoId": "W8rnUWSCiWc",
    "matchYtVideoId": "DJv_VRbAhCs"
  },
  {
    "draftJersey": 30,
    "draftJerseyPrefix": "MED",
    "role": "DF",
    "name": "Lawrence Lonsdale",
    "foot": "right",
    "height": 193,
    "birthdate": "04/01/2001",
    "country": "VEN",
    "macros": {
      "physical": 92,
      "duels": 69,
      "shooting": 59,
      "passing": 84,
      "defence": 94,
      "skills": 52,
      "average": 80
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/920523761.png",
    "profileYtVideoId": "7xiZwmv_wII",
    "matchYtVideoId": "W_28qAbqZCA"
  },
  {
    "draftJersey": 93,
    "draftJerseyPrefix": "MED",
    "role": "DF",
    "name": "Juan Arboleda",
    "foot": "right",
    "height": 178,
    "birthdate": "21/05/2003",
    "country": "COL",
    "macros": {
      "physical": 80,
      "duels": 84,
      "shooting": 79,
      "passing": 88,
      "defence": 78,
      "skills": 78,
      "average": 80
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/857263795.png",
    "profileYtVideoId": "Me6QRvRjxaw",
    "matchYtVideoId": "gvuMCoFcelQ"
  },
  {
    "draftJersey": 103,
    "draftJerseyPrefix": "MED",
    "role": "DL",
    "name": "Cristian Restrepo",
    "foot": "left",
    "height": 175,
    "birthdate": "24/05/1997",
    "country": "COL",
    "macros": {
      "physical": 76,
      "duels": 88,
      "shooting": 75,
      "passing": 91,
      "defence": 80,
      "skills": 78,
      "average": 80
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/761152222.png",
    "profileYtVideoId": "zwWwjSBXou8",
    "matchYtVideoId": "gvuMCoFcelQ"
  },
  {
    "draftJersey": 173,
    "draftJerseyPrefix": "MED",
    "role": "DF",
    "name": "Sebastián Sáez",
    "foot": "right",
    "height": 163,
    "birthdate": "23/02/1997",
    "country": "COL",
    "macros": {
      "physical": 74,
      "duels": 80,
      "shooting": 78,
      "passing": 70,
      "defence": 91,
      "skills": 78,
      "average": 80
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/281912692.png",
    "profileYtVideoId": "23HQXem00WI",
    "matchYtVideoId": "mduLpkOC3Vw"
  },
  {
    "draftJersey": 105,
    "draftJerseyPrefix": "MED",
    "role": "MC",
    "name": "Jose Rojas",
    "foot": "right",
    "height": 181,
    "birthdate": "12/03/1995",
    "country": "COL",
    "macros": {
      "physical": 74,
      "duels": 71,
      "shooting": 75,
      "passing": 86,
      "defence": 95,
      "skills": 65,
      "average": 78
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/488304298.png",
    "profileYtVideoId": "H6S75qlfsPA",
    "matchYtVideoId": "K-L-bXx_Hzc"
  },
  {
    "draftJersey": 37,
    "draftJerseyPrefix": "MED",
    "role": "MC",
    "name": "Diego Losada",
    "foot": "right",
    "height": 173,
    "birthdate": "11/12/2002",
    "country": "DOM",
    "macros": {
      "physical": 81,
      "duels": 70,
      "shooting": 76,
      "passing": 79,
      "defence": 90,
      "skills": 69,
      "average": 77
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/904159541.png",
    "profileYtVideoId": "Uzb7HP-OPL0",
    "matchYtVideoId": "7lvd5X8b4w0"
  },
  {
    "draftJersey": 158,
    "draftJerseyPrefix": "MED",
    "role": "DF",
    "name": "Daniel Mendoza",
    "foot": "right",
    "height": 164,
    "birthdate": "13/03/1999",
    "country": "COL",
    "macros": {
      "physical": 87,
      "duels": 62,
      "shooting": 67,
      "passing": 67,
      "defence": 89,
      "skills": 66,
      "average": 77
    },
    "imageUrl": "https:///kingsleague-cdn.kama.football/account/production/player/743684524.png",
    "profileYtVideoId": "sMnWxPxmmkc",
    "matchYtVideoId": "4bmaEWjDcaA"
  },
  {
    "draftJersey": 104,
    "draftJerseyPrefix": "MED",
    "role": "MC",
    "name": "Andres Rugeles",
    "foot": "right",
    "height": 170,
    "birthdate": "19/04/1994",
    "country": "COL",
    "macros": {
      "physical": 67,
      "duels": 78,
      "shooting": 74,
      "passing": 87,
      "defence": 84,
      "skills": 72,
      "average": 76
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/189219612.png",
    "profileYtVideoId": "98Jrn-OE4CM",
    "matchYtVideoId": "gvuMCoFcelQ"
  },
  {
    "draftJersey": 13,
    "draftJerseyPrefix": "MED",
    "role": "MC",
    "name": "Michel Cardenas",
    "foot": "left",
    "height": 172,
    "birthdate": "26/01/1996",
    "country": "COL",
    "macros": {
      "physical": 74,
      "duels": 72,
      "shooting": 71,
      "passing": 79,
      "defence": 78,
      "skills": 66,
      "average": 74
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/20144647.png",
    "profileYtVideoId": "FntSK4BDtcA",
    "matchYtVideoId": "W_28qAbqZCA"
  },
  {
    "draftJersey": 107,
    "draftJerseyPrefix": "MED",
    "role": "DL",
    "name": "Weimar Murillo",
    "foot": "left",
    "height": 164,
    "birthdate": "17/04/1999",
    "country": "COL",
    "macros": {
      "physical": 86,
      "duels": 71,
      "shooting": 66,
      "passing": 77,
      "defence": 94,
      "skills": 66,
      "average": 74
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/521158115.png",
    "profileYtVideoId": "QUE5Y-fn1Wg",
    "matchYtVideoId": "K-L-bXx_Hzc"
  },
  {
    "draftJersey": 169,
    "draftJerseyPrefix": "MED",
    "role": "MC",
    "name": "Brayan Gonzalez",
    "foot": "right",
    "height": 186,
    "birthdate": "26/05/2001",
    "country": "COL",
    "macros": {
      "physical": 71,
      "duels": 78,
      "shooting": 72,
      "passing": 68,
      "defence": 87,
      "skills": 71,
      "average": 74
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/649203600.png",
    "profileYtVideoId": "wHbwCKWFhGc",
    "matchYtVideoId": "mduLpkOC3Vw"
  },
  {
    "draftJersey": 28,
    "draftJerseyPrefix": "MED",
    "role": "DL",
    "name": "Enzo Risso",
    "foot": "right",
    "height": 174,
    "birthdate": "22/06/2003",
    "country": "URU",
    "macros": {
      "physical": 84,
      "duels": 70,
      "shooting": 66,
      "passing": 76,
      "defence": 86,
      "skills": 65,
      "average": 72
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/750189085.png",
    "profileYtVideoId": "FxFMOnlGwCY",
    "matchYtVideoId": "W_28qAbqZCA"
  },
  {
    "draftJersey": 97,
    "draftJerseyPrefix": "MED",
    "role": "DL",
    "name": "Sebastián Tangarife",
    "foot": "right",
    "height": 179,
    "birthdate": "14/07/1994",
    "country": "COL",
    "macros": {
      "physical": 76,
      "duels": 75,
      "shooting": 57,
      "passing": 73,
      "defence": 83,
      "skills": 52,
      "average": 67
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/329091473.png",
    "profileYtVideoId": "ZD-1KhheNxs",
    "matchYtVideoId": "gvuMCoFcelQ"
  },
  {
    "draftJersey": 148,
    "draftJerseyPrefix": "MED",
    "role": "MC",
    "name": "Juan Veloza",
    "foot": "left",
    "height": 170,
    "birthdate": "22/08/1994",
    "country": "COL",
    "macros": {
      "physical": 58,
      "duels": 72,
      "shooting": 66,
      "passing": 81,
      "defence": 76,
      "skills": 52,
      "average": 68
    },
    "imageUrl": "https://kingsleague-cdn.kama.football/account/production/player/93832955.png",
    "profileYtVideoId": "Ij2s9uUVvQI",
    "matchYtVideoId": "doGH-BDj1Zo"
  }
]
